module.exports = __webpack_public_path__ + "static/media/team_betsalel.049f9f00.png";